export function isExpirationDateExpired(expirationDate: string): boolean {
  const [month, year] = expirationDate.split('/').map(Number);

  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear() % 100;

  if (year !== currentYear) {
    return year < currentYear;
  }

  return month < currentMonth;
}
